import { render, staticRenderFns } from "./selectTags.vue?vue&type=template&id=64bc01c4&scoped=true"
import script from "./selectTags.vue?vue&type=script&lang=js"
export * from "./selectTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc01c4",
  null
  
)

export default component.exports